import React from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <section className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="text-center">
        <div className="text-8xl font-extrabold brand-gradient">404</div>
        <h2 className="mt-4 text-2xl md:text-3xl font-bold text-white">Page nahi mila</h2>
        <p className="mt-2 text-slate-400 max-w-md mx-auto">Looks like you took a wrong turn. Wapas home par chalo aur OnlineCricketID ki best services explore karo.</p>
        <Link to="/" className="btn-gold inline-flex items-center gap-2 px-5 py-3 rounded-xl text-sm mt-6">
          <Home className="w-4 h-4" /> Go Home
        </Link>
      </div>
    </section>
  );
}
